import { jwtDecode } from 'jwt-decode';

const AuthFunctions = {

    AuthHeaders() {
        const tokenString = this.GetAuthToken();
        const userToken = `Bearer ${tokenString}`;
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json',
                'Authorization': userToken }
        };
        return requestOptions;
    },

    ClearAuthToken() {
        document.cookie = 'sid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    },
    
    SaveAuthToken(token) {
        document.cookie = `sid=${token}; path=/`;
    },
    
    TokenValid() {
        const cookies = document.cookie.split('; ');
        const sidCookie = cookies.find(cookie => cookie.startsWith('sid='));
        const userToken = sidCookie ? sidCookie.split('=')[1] : null;
        return userToken !== null;
    },

    GetAuthToken() {
        const cookies = document.cookie.split('; ');
        const sidCookie = cookies.find(cookie => cookie.startsWith('sid='));
        const userToken = sidCookie ? sidCookie.split('=')[1] : null;
        return userToken;
    },

    IsEmptyObject(obj) {
        for(var prop in obj) {
              if(obj.hasOwnProperty(prop)) {
                return false;
              }
        }  
        return JSON.stringify(obj) === JSON.stringify({});
    },

    ExtractTokenUser() {
        try {
            const token = this.GetAuthToken();
            const decodedToken = jwtDecode(token);
            return decodedToken.sub;
        } catch (error) {
            console.error('Error extracting token user:', error);
            return null;
        }
    }

}

export default AuthFunctions;